module.exports = __webpack_public_path__ + "static/media/george.5017f673.jpg";